import { render, staticRenderFns } from "./descriptionSpecialtyCareer.vue?vue&type=template&id=588f907f&scoped=true&"
import script from "./descriptionSpecialtyCareer.vue?vue&type=script&lang=js&"
export * from "./descriptionSpecialtyCareer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588f907f",
  null
  
)

export default component.exports